module.exports = __webpack_public_path__ + "static/media/start_business.4657ee85.png";